var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastorCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.816406,
    width: 38.6755,
    height: 37,
    rx: 18.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.707 13.707L25.293 12.293L20 17.586L14.707 12.293L13.293 13.707L18.586 19L13.293 24.293L14.707 25.707L20 20.414L25.293 25.707L26.707 24.293L21.414 19L26.707 13.707Z",
    fill: "#DA1E27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastorCross);
export default __webpack_public_path__ + "static/media/toastorCross.037002c4ab1ac47bbc9c46fe549adf3b.svg";
export { ForwardRef as ReactComponent };